import { FormUpdatesController } from "./FormUpdatesController";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const loggingEnabled = () => (window as any).DEBUG || (window as any).DEBUG_FORMS || false;

const SPINNER_HTML =
  '<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Submitting...';

const forms = document.querySelectorAll("form.needs-validation");

forms.forEach(function (e) {
  const form = e as HTMLFormElement;
  if (form) {
    form.addEventListener(
      "submit",
      (event) => {
        const isValid = form.checkValidity();

        if (isValid === false) {
          event.preventDefault();
          event.stopPropagation();
        } else if (isValid === true && form.hasAttribute("data-dse-form-indicators")) {
          const buttons = form.querySelectorAll(
            "button[type=submit]",
          ) as NodeListOf<HTMLButtonElement>;

          buttons.forEach((button) => {
            button.disabled = true;
            button.innerHTML = SPINNER_HTML;
          });
        }
        form.classList.add("was-validated");
      },
      false,
    );
    if (loggingEnabled()) {
      console.log(
        "[validation.ts] attached validation to form",
        form.id || form.name || form.action || form,
      );
    }
  }
});

const elements = document.querySelectorAll("form[data-form-updates]");

elements.forEach((e: Element) => {
  const form = e as HTMLFormElement;
  new FormUpdatesController(form);
});
